export const SESSION_STATUSES = {
  NOT_REGISTERED: 'Not Registered',
  NOT_MEET_THRESHOLD: 'Minimum attendance required not met.',
  SCANNING: 'Your attendance for this session will be tracked via scanning.',
  EVALUATION_EXPIRED: 'The evaluation completion date has passed.',
};
